import { Component } from '@angular/core';

@Component({
    moduleId: module.id,
    // tslint:disable-next-line:component-selector
    selector: 'app',
    templateUrl: 'app.component.html'
})
export class AppComponent {

}
